import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01205426"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-left":"20px"} }
const _hoisted_2 = { style: {"margin-left":"20px"} }
const _hoisted_3 = { style: {"margin-left":"20px"} }
const _hoisted_4 = {
  key: 0,
  class: "image_box"
}
const _hoisted_5 = { style: {"text-align":"center"} }
const _hoisted_6 = { style: {"width":"200px","height":"153px","margin-bottom":"5px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无口内照", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请扫码支付：", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", { id: "canvas" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "qrCode" }, null, -1))

import QRCode from "qrcode";
import {useRoute} from "vue-router";
import * as timers from "timers";
import {onMounted, reactive, toRefs, UnwrapRef} from "vue";
import {
    getSaleOrder,
    getSaleOrderQrCode,
    getSaleOrderWxPayStatus,
    getTreatDetailById,
} from "@/api/sale_order";
import {finishTask} from "@/api/home";
import {message} from "ant-design-vue";
import router from "@/router";
import {getPickImage} from "@/api/order";
interface Data {
    amount: number | string,
    treatId: string,
    treatName: string,
    orderId: string,
    noTitleKey: string,
    preloadAmount: string,
    activeKey: any[],
    dataSource: any[],
    roleField: any[],
    imageList: any[],
    tabListNoTitle: any[],
}

export default /*#__PURE__*/_defineComponent({
  __name: 't902',
  setup(__props) {


const route = useRoute();

const data: UnwrapRef<Data> = reactive({
    amount:"暂无",
    treatId:"",
    treatName: "未获取到数据",
    orderId:"",
    noTitleKey: "S1",
    preloadAmount: "未获取到数据",
    activeKey: [],
    dataSource: [],
    roleField: [],
    imageList: [],
    tabListNoTitle: [],
})

const {
    noTitleKey,
    imageList,
    tabListNoTitle,
} = toRefs(data);

let timerId:any = null;

const getQrCode = () => {
    const saleOrderId = route.query.saleOrderId;
    getSaleOrderQrCode(saleOrderId).then((res: any) => {
        console.log(res)
        let canvas = document.getElementById("canvas");
        QRCode.toCanvas(canvas, res.qrCode, function (error) {
            if (error) console.error(error)
            console.log('success!');
            timerId = timers.setInterval(getWxPayStatus, 3000, res.saleOrderId);
        })
    })
}
const getSaleOrderById = async() => {
    const saleOrderId = route.query.saleOrderId;
    await getSaleOrder(saleOrderId).then((res: any) => {
        console.log(res)
        data.amount = res.amount;
        data.treatId = res.treatId;
        data.orderId = res.oralDetectionOrderId
        data.preloadAmount = res.preloadAmount;
    })
    if(data.treatId){
        await getTreatDetailById(data.treatId).then((res: any)=>{
            data.treatName = res.treatName;
        })
    }
    if(data.orderId){
        await getPickImage(data.orderId).then((res: any) => {
            console.log(res);
            tabListNoTitle.value = [];
            imageList.value = res.map((item: any) => {
                item.files = item.files.split(",");
                tabListNoTitle.value.push({
                    key: item.phase,
                    tab: tabType(item.phase),
                });
                return item;
            });
        })
    }
}
const onTabChange = (value: string) => {
    noTitleKey.value = value;
};
const tabType = (type: string) => {
    switch (type) {
        case "S1":
            return "闭口图片";
        case "S2":
            return "开口图片";
        case "S3":
            return "颌面图片";
        default:
            break;
    }
};
const imageTitle = (value: any) => {
    if (noTitleKey.value == "S3") {
        switch (value) {
            case 0:
                return "上颌";
            case 1:
                return "下颌";
            default:
                break;
        }
    } else {
        switch (value) {
            case 0:
                return "左侧";
            case 1:
                return "中间";
            case 2:
                return "右侧";
            default:
                break;
        }
    }
};
const getWxPayStatus = (saleOrderId: any) => {
    getSaleOrderWxPayStatus(saleOrderId).then((res: any) => {
        console.log(res.success);
        if (res.success) {
            timers.clearInterval(timerId);
            pay(saleOrderId)
        }
    })
}


const pay = (saleOrderId: any) => {
    let processDefinitionId = route.query.processDefinitionId;
    let processInstanceId = route.query.processInstanceId;
    let processDefinitionKey = route.query.processDefinitionKey;
    let runTimeTaskId = route.query.runTimeTaskId;
    let taskCode = route.query.taskCode

    let parameters = {
        processDefinitionId: processDefinitionId,
        processInstanceId: processInstanceId,
        processDefinitionKey: processDefinitionKey,
        runTimeTaskId: runTimeTaskId,
        taskCode: taskCode,
        params: {saleOrderId: saleOrderId}
    };
    finishTask(parameters).then(() => {
        message.success("操作成功");
        router.push({
            path: "/home",
        });
    });
}


onMounted(() => {
    getSaleOrderById();
    getQrCode()
})


return (_ctx: any,_cache: any) => {
  const _component_pay_circle_outlined = _resolveComponent("pay-circle-outlined")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_fund_projection_screen_outlined = _resolveComponent("fund-projection-screen-outlined")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, {
          title: "订单信息",
          layout: "vertical",
          bordered: "",
          column: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "付款金额" }, {
              default: _withCtx(() => [
                _createVNode(_component_pay_circle_outlined, { style: {"color":"#42b983","font-size":"14px"} }),
                _createElementVNode("span", _hoisted_1, _toDisplayString(data.amount) + "元", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "治疗项目" }, {
              default: _withCtx(() => [
                _createVNode(_component_fund_projection_screen_outlined, { style: {"color":"#42b983","font-size":"14px"} }),
                _createElementVNode("span", _hoisted_2, _toDisplayString(data.treatName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "预计价格" }, {
              default: _withCtx(() => [
                _createVNode(_component_pay_circle_outlined, { style: {"color":"#42b983","font-size":"14px"} }),
                _createElementVNode("span", _hoisted_3, _toDisplayString(data.preloadAmount) + "元", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            (_unref(imageList) && _unref(imageList).length>0)
              ? (_openBlock(), _createBlock(_component_a_card, {
                  key: 0,
                  style: {"width":"100%","margin-top":"20px","height":"500px"},
                  "tab-list": _unref(tabListNoTitle),
                  "active-tab-key": _unref(noTitleKey),
                  onTabChange: onTabChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imageList), (it) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: it.id
                      }, [
                        (it.phase == _unref(noTitleKey))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(it.files, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  _createElementVNode("div", _hoisted_5, _toDisplayString(imageTitle(index)), 1),
                                  _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_component_a_image, {
                                      style: {"width":"200px","height":"153px"},
                                      src: it.prefix + '/' + item + '.JPEG',
                                      fit: "contain"
                                    }, null, 8, ["src"])
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["tab-list", "active-tab-key"]))
              : (_openBlock(), _createBlock(_component_a_card, {
                  key: 1,
                  style: {"width":"100%","margin-top":"20px","height":"500px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { style: {"margin-top":"20px","height":"500px"} }, {
              default: _withCtx(() => [
                _hoisted_8,
                _hoisted_9,
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})